import React from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
import {
  FiArrowRight,
  FiCalendar,
  FiChevronRight,
  FiClock,
  FiFileText,
  FiHome,
  FiUser,
} from "react-icons/fi";
import { MdWavingHand } from "react-icons/md";

const formatAmount = (value) => {
  const numericValue = Number(String(value || "").replace(/[^\d.]/g, ""));

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return "₹23,800";
  }

  return `₹${numericValue.toLocaleString("en-IN")}`;
};

const ActiveLoanHomePage = ({
  setScreen,
  customerName = "Customer",
  loanAmount = "",
}) => {
  const displayName = customerName || "Customer";
  const displayAmount = formatAmount(loanAmount);

  return (
    <section className="fw-screen fw-active-loan fw-fade">
          <div className="fw-active-loan__scroll">
      {/* Header */}
   <header className="fw-active-loan__header">
  <div className="fw-brandmain">
    <img
      src={fundwalelogo}
      alt="Fundswalle"
      className="fw-brand__logo1"
    />
  </div>

  <button
    type="button"
    className="fw-active-loan__profile"
    onClick={() => setScreen("/apply-new/profile")}
    aria-label="Open profile"
  >
    <FiUser />
  </button>
</header>

      {/* Greeting */}
      <div className="fw-active-loan__welcome">
        <p className="fw-active-loan__eyebrow">WELCOME BACK</p>

        <h1>
          Hi,{" "}
          <span>
            {displayName.split(" ")[0]}
          </span>
           <MdWavingHand className="fw-welcome-hand" />
        </h1>

        <p>
          Here’s an overview of your active loan.
        </p>
      </div>

      {/* Active Loan Card */}
      <div className="fw-active-loan__card">
        <div className="fw-active-loan__card-head">
          <div>
            <span className="fw-active-loan__label">
              ACTIVE LOAN
            </span>

            <h2>Your Current Loan</h2>
          </div>

          <span className="fw-active-loan__status">
            ACTIVE
          </span>
        </div>

        <div className="fw-active-loan__amount">
          <span>Outstanding Amount</span>

          <strong>{displayAmount}</strong>
        </div>

        <div className="fw-active-loan__details">
          <div className="fw-active-loan__detail">
            <span className="fw-active-loan__detail-icon">
              <FiCalendar />
            </span>

            <div>
              <small>Next Repayment</small>
              <strong>22 Sep 2026</strong>
            </div>
          </div>

          <div className="fw-active-loan__detail">
            <span className="fw-active-loan__detail-icon">
              <FiClock />
            </span>

            <div>
              <small>Loan Status</small>
              <strong>Active</strong>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="fw-btn fw-btn--primary fw-active-loan__pay"
          onClick={() => setScreen("/apply-new/repayment")}
        >
          Make a Repayment
          <FiArrowRight />
        </button>
      </div>

      {/* Quick Actions */}
      <div className="fw-active-loan__section">
        <div className="fw-active-loan__section-head">
          <h2>Quick Actions</h2>
        </div>

        <div className="fw-active-loan__actions">
          <button
            type="button"
            className="fw-active-loan__action"
            onClick={() => setScreen("/apply-new/repayment")}
          >
            <span className="fw-active-loan__action-icon">
              <FiFileText />
            </span>

            <span className="fw-active-loan__action-copy">
              <strong>Repayment</strong>
              <small>Pay your loan</small>
            </span>

            <FiChevronRight />
          </button>

          <button
            type="button"
            className="fw-active-loan__action"
            onClick={() => setScreen("/apply-new/profile")}
          >
            <span className="fw-active-loan__action-icon">
              <FiUser />
            </span>

            <span className="fw-active-loan__action-copy">
              <strong>My Profile</strong>
              <small>View your profile</small>
            </span>

            <FiChevronRight />
          </button>
        </div>
      </div>

      {/* Loan Information */}
      <div className="fw-active-loan__info">
        <div className="fw-active-loan__info-icon">
          <FiFileText />
        </div>

        <div>
          <strong>Need help with your loan?</strong>
          <p>
            You can check your repayment details or contact
            Fundswalle support from your profile.
          </p>
        </div>
      </div>
  </div>
      {/* Bottom Navigation */}
      <nav className="fw-active-loan__bottom-nav">
        <button
          type="button"
          className="is-active"
          onClick={() => setScreen("/apply-new/activeLoanHome")}
        >
          <FiHome />
          <span>Home</span>
        </button>

        <button
          type="button"
          onClick={() => setScreen("/apply-new/repayment")}
        >
          <FiFileText />
          <span>Repayment</span>
        </button>

        <button
          type="button"
          onClick={() => setScreen("/apply-new/profile")}
        >
          <FiUser />
          <span>Profile</span>
        </button>
      </nav>
    </section>
  );
};

export default ActiveLoanHomePage;